export default __webpack_public_path__ + "static/media/photo_5282747746622312919_y.e5a7412c.jpg";